import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Form, Input, message } from "antd";
import { Typography } from "antd";
import React from "react";
import { useHistory } from "react-router-dom";
import "./login.css";
import { login } from "../../api";

const { Title } = Typography;

const Login = ({ setToken }) => {

  let history = useHistory();

  const onFinish = (values) => {
    login(values)
      .then((response) => response.json())
      .then((data) => {
        if (data.code === 200) {
          setToken(data.result);
          history.push("/admin");
        }else{
          message.error(`登录失败，原因：${data.msg}`);
        }
      })
      .catch((error) => {
        message.error(`登录失败，原因：${error}`);
      });
  };

  return (
    <div className="login_container">
      <Title className="login_title" level={3}>
        FreeView-精彩时刻上传平台
      </Title>
      <Form
        name="normal_login"
        className="login-form"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
      >
        <Form.Item
          name="username"
          rules={[
            {
              required: true,
              message: "请输入邮箱!",
            },
          ]}
        >
          <Input
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder="邮箱"
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: "请输入密码!",
            },
          ]}
        >
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
            placeholder="密码"
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            登录
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login;
